import { Link, Text } from '@bancobarigui/barihaus';

import { FormLogo } from '@/components/FormLogo';
import { RecoverPasswordForm } from './RecoverPasswordForm';
import { PublicRouteContainer } from '@/components/PublicRouteContainer';

import { useRecoverPassword } from './useRecoverPassword';

export default function RecoverPassword() {
  const { onSubmit, backToLogin } = useRecoverPassword();

  return (
    <PublicRouteContainer>
      <FormLogo />

      <Text>Solicite a recuperação de senha para seu email.</Text>
      
      <RecoverPasswordForm onSubmit={onSubmit} />

      <Link onClick={backToLogin}>Voltar para Login</Link>
    </PublicRouteContainer>
  );
}
